import React from 'react';
import { useStaticQuery, graphql } from 'gatsby'
import Img from "gatsby-image"
import MUiPaper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles( theme => ({
  paper: {
    fontSize: '1.5em',
    backgroundColor: '#f7f0e3',
    padding: '10px',
    border: 'none',
    borderRadius: '0',
    boxShadow: 'none'
  },
  paperContainer: {
    padding: '15px',
    position: 'relative'
  },
  leftTop: {
    position: 'absolute !important',
    left: 0,
    top: 0
  },
  rightTop: {
    transform: 'scaleX(-1)',
    position: 'absolute !important',
    right: 0,
    top: 0
  },
  rightBottom: {
    transform: 'scale(-1)',
    position: 'absolute !important',
    right: 0,
    bottom: 0
  },
  leftBottom: {
    transform: 'scaleY(-1)',
    position: 'absolute !important',
    left: 0,
    bottom: 0
  },
  content: {
    minHeight: '400px',
    padding: '50px 20px'
  },
  borderLine: {
    height: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#838075',
    color: '#838075',
    width: 'calc(100% - 300px)',
    position: 'absolute',
    top: '19px',
    left: '150px'
  },
  borderLineDot: {
    width: '30px',
    textAlign: 'center',
    fontSize: '20px',
    backgroundColor: '#f7f0e3',
    zIndex: 1
  },
  lineLeft: {
    width: '3px',
    height: 'calc(100% - 300px)',
    left: '20px',
    top: '150px'
  },
  lineBottom: {
    height: '2.5px',
    top: 'auto',
    bottom: '19px'
  },
  lineRight: {
    width: '2px',
    height: 'calc(100% - 300px)',
    left: 'auto',
    right: '21.5px',
    top: '150px'
  },
  '@media screen and (min-width: 799px)': {
    paper: {
      padding: '30px'
    }
  }
}))

const Paper = (props) => {
  const classes = useStyles();

  const paper = useStaticQuery(graphql`
    query {
      corner: file(relativePath: { eq: "main/corner.png" }) {
        childImageSharp {
          fixed(width: 150) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
  <MUiPaper {...props} className={classes.paper}>
    <div  className={classes.paperContainer}>
      <div className={`${classes.content} `}>
        {props.children}
      </div>
      <div className={classes.borderLine}><i className={`material-icons ${classes.borderLineDot}`}>fiber_manual_record</i></div>
      <div className={`${classes.borderLine}  ${classes.lineLeft}`}><i className={`material-icons ${classes.borderLineDot}`}>fiber_manual_record</i></div>
      <div className={`${classes.borderLine}  ${classes.lineBottom}`}><i className={`material-icons ${classes.borderLineDot}`}>fiber_manual_record</i></div>
      <div className={`${classes.borderLine}  ${classes.lineRight}`}><i className={`material-icons ${classes.borderLineDot}`}>fiber_manual_record</i></div>
      <Img fixed={paper.corner.childImageSharp.fixed} className={classes.leftTop} />
      <Img fixed={paper.corner.childImageSharp.fixed} className={classes.rightTop} />
      <Img fixed={paper.corner.childImageSharp.fixed} className={classes.leftBottom} />
      <Img fixed={paper.corner.childImageSharp.fixed} className={classes.rightBottom} />
    </div>
  </MUiPaper>
  )
}

export default Paper